export default __webpack_public_path__ + "static/media/mouse.cf3a11e1.svg";